var _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnerPel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 139,
    viewBox: "0 0 120 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1344_7973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0856 3.00008C90.4378 3.00008 117.012 32.6175 117.012 69.1525C117.012 105.687 89.0476 136 57.6953 136",
    stroke: "url(#paint0_radial_1344_7973)",
    strokeOpacity: 0.9,
    strokeWidth: 5.68293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0856 3.00008C90.4378 3.00008 117.012 32.6175 117.012 69.1525C117.012 105.687 89.0476 136 57.6953 136",
    stroke: "url(#paint1_radial_1344_7973)",
    strokeOpacity: 0.9,
    strokeWidth: 5.68293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0856 3.00008C90.4378 3.00008 117.012 32.6175 117.012 69.1525C117.012 105.687 89.0476 136 57.6953 136",
    stroke: "url(#paint2_radial_1344_7973)",
    strokeOpacity: 0.9,
    strokeWidth: 5.68293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0856 3.00008C90.4378 3.00008 117.012 32.6175 117.012 69.1525C117.012 105.687 89.0476 136 57.6953 136",
    stroke: "url(#paint3_radial_1344_7973)",
    strokeOpacity: 0.9,
    strokeWidth: 5.68293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0856 3.00008C90.4378 3.00008 117.012 32.6175 117.012 69.1525C117.012 105.687 89.0476 136 57.6953 136",
    stroke: "url(#paint4_radial_1344_7973)",
    strokeOpacity: 0.9,
    strokeWidth: 5.68293
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.058 69.1525C115.058 32.6584 89.6738 3.10156 58.3916 3.10156C27.1083 3.10156 0.566325 33.3549 0.566325 69.8476C0.566325 106.342 25.9509 135.899 57.2331 135.899C88.5164 135.899 115.058 105.645 115.058 69.1525Z",
    fill: "url(#paint5_linear_1344_7973)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.058 69.1525C115.058 32.6584 89.6738 3.10156 58.3916 3.10156C27.1083 3.10156 0.566325 33.3549 0.566325 69.8476C0.566325 106.342 25.9509 135.899 57.2331 135.899C88.5164 135.899 115.058 105.645 115.058 69.1525Z",
    stroke: "url(#paint6_radial_1344_7973)",
    strokeWidth: 0.202962
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.058 69.1525C115.058 32.6584 89.6738 3.10156 58.3916 3.10156C27.1083 3.10156 0.566325 33.3549 0.566325 69.8476C0.566325 106.342 25.9509 135.899 57.2331 135.899C88.5164 135.899 115.058 105.645 115.058 69.1525Z",
    stroke: "url(#paint7_linear_1344_7973)",
    strokeOpacity: 0.05,
    strokeWidth: 0.202962
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_1344_7973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.359 68.9551C109.359 36.1119 86.5115 9.48713 58.3273 9.48713C30.143 9.48713 5.55859 37.4319 5.55859 70.2752C5.55859 103.118 28.4064 129.743 56.5907 129.743C84.7749 129.743 109.359 101.798 109.359 68.9551Z",
    fill: "#0A0C0E",
    fillOpacity: 0.1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 68.9551C109.156 36.1937 86.3714 9.69009 58.3273 9.69009C30.2804 9.69009 5.76156 37.5169 5.76156 70.2752C5.76156 103.037 28.5465 129.54 56.5907 129.54C84.6376 129.54 109.156 101.713 109.156 68.9551Z",
    stroke: "url(#paint8_linear_1344_7973)",
    strokeOpacity: 0.15,
    strokeWidth: 0.405923
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 68.9551C109.156 36.1937 86.3714 9.69009 58.3273 9.69009C30.2804 9.69009 5.76156 37.5169 5.76156 70.2752C5.76156 103.037 28.5465 129.54 56.5907 129.54C84.6376 129.54 109.156 101.713 109.156 68.9551Z",
    stroke: "url(#paint9_linear_1344_7973)",
    strokeOpacity: 0.25,
    strokeWidth: 0.405923
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4657 75.652C78.3825 74.6592 75.7682 75.5728 74.6325 77.6928C74.3779 78.1692 73.9437 78.7682 73.3543 79.4047C72.4818 80.3665 71.2794 81.3649 70.0202 82.2348C68.761 83.1047 67.4326 83.845 66.3663 84.3206C63.3808 85.6519 60.3119 86.1581 57.3592 85.929C56.0619 85.8284 54.7854 85.5805 53.5634 85.2128C51.3362 84.5315 48.8606 85.7907 48.0199 88.0327C47.1915 90.2757 48.3186 92.6456 50.5439 93.3393C52.3507 93.9012 54.2363 94.2583 56.1636 94.4079C60.5371 94.7472 65.1388 94.0002 69.5252 92.0333C71.7264 91.038 74.1118 89.6228 76.3602 87.8498C77.4835 86.9693 78.5713 85.9869 79.5598 84.91C80.5485 83.8331 81.4523 82.6503 82.179 81.305C83.3165 79.1728 82.5489 76.6447 80.4657 75.652Z",
    fill: "#FCA311"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.187 68.5661C86.4536 64.8158 85.8835 60.9758 84.3946 57.3622C83.0834 54.1717 81.1505 51.4043 78.808 49.151C76.4513 46.909 73.6742 45.1678 70.6518 44.0153C68.4826 43.1896 65.9412 44.2949 64.9698 46.4896C63.9984 48.6843 64.9651 51.1286 67.1344 51.9543C69.1852 52.7336 71.0554 53.9084 72.6406 55.4206C74.226 56.933 75.514 58.7819 76.4076 60.9477C77.422 63.4081 77.7856 65.9668 77.6163 68.4966C77.4482 70.8405 79.2392 72.7533 81.6091 72.7759C83.9666 72.7975 86.0189 70.91 86.187 68.5661Z",
    fill: "#FCA311"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9573 51.056C60.3225 50.6689 62.0297 48.4816 61.7816 46.1676C61.5333 43.8534 59.4168 42.2999 57.0516 42.687C54.7252 43.0647 52.3925 43.7521 50.0997 44.7774C45.5264 46.8291 41.7096 49.9815 38.895 53.7326C36.0805 57.4838 34.2664 61.8459 33.6262 66.3859C33.6037 66.5454 33.5812 66.705 33.5587 66.8645L29.9287 92.6077C29.5999 94.9391 31.2343 96.9886 33.5941 97.1717C35.9538 97.3548 38.1229 95.6128 38.4534 93.2691L42.1543 67.0227C42.1561 67.0104 42.1595 66.986 42.1613 66.9737C42.601 63.9438 43.8262 61.0122 45.7038 58.5032C47.5971 55.9707 50.1427 53.861 53.2498 52.4646C54.8077 51.7792 56.3839 51.3185 57.9573 51.056Z",
    fill: "#FCA311"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1344_7973",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 57,
    width: 25,
    height: 23
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7136 76.7308C71.5148 72.8856 72.484 66.1011 68.8752 61.5788C65.2664 57.0564 58.4342 56.5263 53.6206 60.3704C48.8194 64.2155 46.5683 75.7508 48.3745 77.9998C50.1683 80.2477 61.9001 80.5749 66.7136 76.7308Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1344_7973)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint10_linear_1344_7973)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint11_radial_1344_7973)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint12_radial_1344_7973)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint13_radial_1344_7973)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint14_radial_1344_7973)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint15_radial_1344_7973)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint16_linear_1344_7973)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint17_radial_1344_7973)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint18_radial_1344_7973)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint19_radial_1344_7973)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6044 69.9181C76.1867 79.9724 66.8299 87.4863 56.7055 86.7009C46.5811 85.9154 39.523 77.128 40.9407 67.0736C42.3585 57.0193 51.7153 49.5054 61.8397 50.2909C71.9641 51.0764 79.0222 59.8638 77.6044 69.9181Z",
    fill: "url(#paint20_radial_1344_7973)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1344_7973",
    x: 43.488,
    y: -14.0486,
    width: 90.5748,
    height: 167.097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.10366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1344_7973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1344_7973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_1344_7973",
    x: 3.9349,
    y: 7.86361,
    width: 107.048,
    height: 123.503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.62369,
    dy: -2.43554
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.811846
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.316667 0 0 0 0 0.316667 0 0 0 0 0.316667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1344_7973"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.62369,
    dy: 2.43554
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.811846
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1344_7973",
    result: "effect2_innerShadow_1344_7973"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.62369,
    dy: -1.62369
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.811846
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1344_7973",
    result: "effect3_innerShadow_1344_7973"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.384 41.5793) rotate(126.521) scale(26.67 11.8946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302247,
    stopColor: "#721A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#721A31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.939 99.1586) rotate(-137.954) scale(66.7723 29.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.092 130.555) rotate(-94.7802) scale(33.366 14.881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.098 92.7866) rotate(-143.444) scale(50.7678 43.7806)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00401228,
    stopColor: "#311288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#6EF2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#F3F34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFFFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.3538 69.5) rotate(-84.1304) scale(62.3083 27.7891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1344_7973",
    x1: 117.158,
    y1: 89.8984,
    x2: -32.9802,
    y2: 52.6776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459707,
    stopColor: "#363636",
    stopOpacity: 0.971584
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827067,
    stopColor: "#0A0A0A",
    stopOpacity: 0.995031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-25.1388 31.8476) rotate(25.9442) scale(86.0636 74.2186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1344_7973",
    x1: 51.3246,
    y1: 69.5,
    x2: 178.068,
    y2: 12.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606261"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1344_7973",
    x1: -45.8804,
    y1: 132.176,
    x2: 93.0387,
    y2: 88.7949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58CBC2",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1344_7973",
    x1: 140.876,
    y1: 53.8591,
    x2: 52.8068,
    y2: 78.1155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1344_7973",
    x1: 61.2514,
    y1: 54.4629,
    x2: 67.2397,
    y2: 82.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA1DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.7753 85.4919) rotate(-124.36) scale(18.1478 18.5085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909ADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.0056 51.002) rotate(123.849) scale(21.0641 19.1911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8874FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8874FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1388 46.996) rotate(42.3009) scale(32.3854 27.879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1353 52.1399) rotate(51.2282) scale(13.1117 10.1392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.3554 69.0454) rotate(56.4427) scale(10.0541 8.82402)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1344_7973",
    x1: 61.2514,
    y1: 54.4629,
    x2: 67.2397,
    y2: 82.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA1DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.7753 85.4919) rotate(-124.36) scale(18.1478 18.5085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909ADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.0056 51.002) rotate(123.492) scale(24.5486 22.3764)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8874FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8874FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1388 46.996) rotate(45.5818) scale(33.0656 28.5132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1344_7973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1353 52.1399) rotate(49.6433) scale(18.7929 14.531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerPel);
export default __webpack_public_path__ + "static/media/partner-pel.1696c4e122c24894ac49388274c955eb.svg";
export { ForwardRef as ReactComponent };